import { createFilterOptionsSlice } from '@skynet/data-filter-options';
import type { FilterOptions, PersistOptions } from '@skynet/data-filter-options';

export interface DexTaskFilterOptions {
  direction: string[];
  type: string[];
  status: string[];
  autoUpdate: boolean;
}

export type DexTaskFilterState = FilterOptions<DexTaskFilterOptions>;

export const initialDexTaskFilterOptions: DexTaskFilterOptions = {
  direction: [],
  type: [],
  status: [],
  autoUpdate: true,
};

/**
 * Persist config for the filter slice. The app mounts the slice under
 * `dex.tasks.filter`, wraps it with `persistReducer` and its own storage, and
 * keeps this key so the persisted filters survive upgrades.
 */
export const DEX_TASK_FILTER_PERSIST_CONFIG = {
  key: 'dexTasks/filter',
  // Persist direction / type / status so they survive navigation.
  // Do NOT persist autoUpdate (volatile UI preference) or search/sort
  // (BaseFilterOptions blacklists them automatically).
  blacklist: ['sort', 'search', 'autoUpdate'],
} as const satisfies PersistOptions & { key: string };

export const dexTaskFilterSlice = createFilterOptionsSlice<DexTaskFilterOptions>({
  prefix: 'dexTasks',
  initialState: initialDexTaskFilterOptions,
  clearState: {
    direction: [],
    type: [],
    status: [],
    autoUpdate: true,
    search: '',
    sort: '',
  },
});

export const dexTaskFilterActions = dexTaskFilterSlice.actions;
